import { render, staticRenderFns } from "./plan-list-table.vue?vue&type=template&id=0f83745c&"
import script from "./plan-list-table.vue?vue&type=script&lang=js&"
export * from "./plan-list-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QInnerLoading,QSpinnerIos,QInput,QIcon,QTr,QTh,QTd,QBtn,QTooltip,QToggle,QImg,QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QInnerLoading,QSpinnerIos,QInput,QIcon,QTr,QTh,QTd,QBtn,QTooltip,QToggle,QImg,QCard})
